import { datajs, datajsAll } from '../shared/utils';
import { CountUp } from 'countup.js';

export default class FactsBlock {
	static init() {
		const factItems = datajsAll('fact-item');

		factItems.forEach((factItem, index) => {
			setTimeout(() => {
				this.setupFactItem(factItem);
			}, index * 500); // Add a slight out of sync effect
		});
	}

	// Setup Fact Item
	static setupFactItem(factItem) {
		let numberElement = datajs('number', factItem);
		let shouldFormatNumber = numberElement.dataset.formatNumber ? true : false;
		let numberValue = parseFloat(numberElement.innerText);
		let decimalPlaces = 0;
		let countUpFrom = 0;

		if (isNaN(numberValue)) {
			return;
		}

		numberElement.innerText = 0;

		// Allow 1 decimal places
		if (numberValue % 1 != 0) {
			decimalPlaces = 1;
		}

		// Calculate count up from value
		if (numberValue - 100 > 0) {
			countUpFrom = numberValue - 100;
		}

		let countUpOptions = {
			startVal: countUpFrom,
			duration: 5,
			enableScrollSpy: true,
			scrollSpyOnce: true,
			useGrouping: shouldFormatNumber,
			separator: '&nbsp;',
			decimalPlaces: decimalPlaces,
		};

		new CountUp(numberElement, numberValue, countUpOptions);
	}
}
